module.exports = __webpack_public_path__ + "img/gebilaowang.6c0f6c8e.png";